import { render } from "./AppContainer.vue?vue&type=template&id=00d12057"
import script from "./AppContainer.vue?vue&type=script&lang=js"
export * from "./AppContainer.vue?vue&type=script&lang=js"

import "./AppContainer.vue?vue&type=style&index=0&id=00d12057&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__